import { ButtonProps } from 'antd/lib/button';
import classNames from 'classnames';
import React, { FC } from 'react';
import styled from 'styled-components';
import { FieldOption, StatusGroup } from 'api/tasks';
import { Button as ButtonAtom } from 'components/atoms/button';
import { StatusIndicator } from 'components/molecules/status-indicator';
import { useStatusPickerContext } from './context';

const Button = styled(ButtonAtom)`
  &.ant-btn-icon-only {
    > span {
      height: 20px;
      width: 20px;
    }
  }
  /* Status indicator svg has been wrapped with span tag. So we need to apply margin right manually.*/
  &:not(.ant-btn-icon-only) > span:first-child {
    margin-right: var(--spacing-04);
  }
`;

type StatusTriggerProps = Omit<
  ButtonProps & {
    progress?: number;
    showIcon?: boolean;
    showText?: boolean;
    iconSize?: 'small';
    selectedStatus?: FieldOption<StatusGroup>;
  },
  'icon'
>;

export const StatusPickerTrigger: FC<StatusTriggerProps> = ({
  className,
  children,
  progress = 0,
  showIcon = true,
  showText = false,
  iconSize,
  selectedStatus,
  size = 'small',
  ...rest
}) => {
  const { isOpen, toggle, selected, type } = useStatusPickerContext();

  const onClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (toggle) {
      toggle(!isOpen);
    }
  };

  return (
    <Button
      data-cy="status_picker.trigger"
      className={classNames('status-picker', className)}
      size={size}
      {...rest}
      icon={
        showIcon &&
        selectedStatus && (
          <StatusIndicator
            progress={progress}
            showTooltip={!showText}
            status={selectedStatus as Required<FieldOption<StatusGroup>>}
            type={type}
          />
        )
      }
      type={selected ? 'text' : 'link'}
      onClick={onClick}
    >
      {showText && selectedStatus?.label}
    </Button>
  );
};
